import {useState, useEffect} from 'react';
import dayjs from 'dayjs';
import http from '../../../../services/http';

import {ListaTimes} from "../../../../components/ListaTimes";
import {alerta} from "../../../../components/Alert";

export default function BolaoEditar(props) {
  const {id} = props.match.params;

  const [loadingAtivo, setLoadingAtivo] = useState(true);
  const [bolao, setBolao] = useState(null);
  const [bloqueado, setBloqueado] = useState(false);
  const [credenciais, setCredenciais] = useState({});
  const [confrontos, setConfrontos] = useState([]);
  const [times, setTimes] = useState([]);
  const [campeonato] = useState({});

  useEffect(() => {
    const carregar = async () => {
      try {
        const {data: {data}} = await http.get('/boloes/' + id);
        setBolao(data);

        const temApostas = (data.bilhetes ?? []).some(b => b.situacao !== 'cancelado');
        if (temApostas) {
          setBloqueado(true);
        }

        setCredenciais({
          nome: data.nome,
          tipo: data.tipo,
          valor: data.valor,
          premio1: data.primeiro_premio,
          premio2: data.segundo_premio,
          premio3: data.terceiro_premio,
          porcentagemPremio: data.porcentagem_premio,
          premioAcumulado: data.premio_acumulado,
        });

        const confrontosCarregados = (data.times ?? []).map(t => {
          const dt = dayjs(t.data_inicio);
          return {
            matche_id: t.matche_id ?? '',
            casa: t.time_casa,
            fora: t.time_fora,
            data: dt.format('YYYY-MM-DD'),
            hora: dt.format('HH:mm'),
          };
        });
        setConfrontos(confrontosCarregados);

        setLoadingAtivo(false);
      } catch (e) {
        setLoadingAtivo(false);
        alerta(e.response?.data ?? {success: false, message: 'Erro ao carregar bolão'});
      }
    };
    carregar();
  }, [id]);

  const adicionarTime = () => {
    if (confrontos.length === 10) return;
    setConfrontos([...confrontos, {matche_id: '', casa: '', fora: '', data: '', hora: ''}]);
  };

  const removerTime = () => {
    if (confrontos.length === 6) return;
    confrontos.pop();
    setConfrontos([...confrontos]);
  };

  const defineCredenciais = (ev) => {
    const {name, value} = ev.target;
    setCredenciais({...credenciais, [name]: value});
  };

  const defineConfrontos = (ev) => {
    const {name, value, id: index} = ev.target;
    confrontos.forEach((el, ind) => {
      if (index == ind) {
        const matche = campeonato.matches && campeonato.matches.find(m => {
          if (m.awayTeam.name === el.fora && m.homeTeam.name === el.casa) {
            return m;
          }
        });
        el.casa = name === 'casa' ? value : el.casa;
        el.fora = name === 'fora' ? value : el.fora;
        el.data = name === 'data' ? value : el.data;
        el.hora = name === 'hora' ? value : el.hora;
        el.matche_id = matche && matche.id;
      }
    });
  };

  const salvarBolao = async (ev) => {
    ev.preventDefault();

    if (bloqueado) {
      alerta({success: false, message: 'Não é possível alterar este bolão pois já existem apostas feitas.'});
      return;
    }

    const confrontos_times = [];

    try {
      const confronto = confrontos.reduce((ant, att) => (
        new Date(ant.data + ' ' + ant.hora) < new Date(att.data + ' ' + att.hora) ? ant : att
      ));

      confrontos.forEach((el) => {
        confrontos_times.push({
          time_casa: el.casa,
          time_fora: el.fora,
          matche_id: el.matche_id || null,
          placar_casa: 0,
          placar_fora: 0,
          data_inicio: el.data + ' ' + el.hora,
        });
      });

      await http.put('/boloes/' + id, {
        nome: credenciais.nome,
        valor: credenciais.valor,
        tipo: credenciais.tipo,
        primeiro_premio: credenciais.tipo === 'placar' ? credenciais.premio1 : 0,
        segundo_premio: credenciais.tipo === 'placar' ? credenciais.premio2 : 0,
        terceiro_premio: credenciais.tipo === 'placar' ? credenciais.premio3 : 0,
        porcentagem_premio: credenciais.tipo === 'pontos' ? credenciais.porcentagemPremio : 0,
        premio_acumulado: credenciais.tipo === 'pontos' ? credenciais.premioAcumulado : 0,
        data_limite: confronto.data + ' ' + confronto.hora,
        confrontos: confrontos_times,
      });

      alerta({success: true, message: 'Bolão atualizado com sucesso!'});
      props.history.push('/bolao');
    } catch (error) {
      alerta(error.response?.data ?? {success: false, message: 'Erro ao salvar'});
    }
  };

  if (loadingAtivo) {
    return <div className="loader"/>;
  }

  if (!bolao) {
    return <div className="conteudo-principal">Bolão não encontrado.</div>;
  }

  return (
    <form onSubmit={salvarBolao}>
      <div className="titulo-principal">Editar Bolão</div>

      {bloqueado && (
        <div className="conteudo-principal" style={{background: '#fff3cd', border: '1px solid #ffc107', color: '#856404', marginBottom: 8}}>
          ⚠️ Este bolão já tem apostas — alterações estão bloqueadas.
        </div>
      )}

      <div className="conteudo-principal">
        <div className="d-flex tres-colunas">
          <div className="form-group">
            <label className="control-label">Nome</label>
            <input
              required
              type="text"
              className="form-control"
              onChange={defineCredenciais}
              name='nome'
              value={credenciais.nome ?? ''}
              disabled={bloqueado}
            />
          </div>
          <div className="form-group">
            <label className="control-label">Valor</label>
            <select
              className="form-control"
              onChange={defineCredenciais}
              name='valor'
              value={credenciais.valor ?? ''}
              disabled={bloqueado}
            >
              <option value=""></option>
              <option value="2">2</option>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
              <option value="50">50</option>
            </select>
          </div>
          <div className="form-group">
            <label className="control-label">Tipo</label>
            <select
              className="form-control"
              onChange={defineCredenciais}
              name='tipo'
              value={credenciais.tipo ?? ''}
              disabled={bloqueado}
            >
              <option value=""></option>
              <option value="pontos">Pontos</option>
              <option value="placar">Placar</option>
            </select>
          </div>
        </div>

        <div className="d-flex tres-colunas">
          <div className="form-group">
            {credenciais.tipo === 'placar' ? (
              <>
                <label className="control-label">{confrontos.length} acertos</label>
                <input
                  required
                  type="number"
                  inputMode="decimal"
                  className="form-control"
                  onChange={defineCredenciais}
                  name='premio1'
                  value={credenciais.premio1 ?? ''}
                  disabled={bloqueado}
                />
              </>
            ) : (
              <>
                <label className="control-label">% Premio</label>
                <input
                  required
                  type="number"
                  inputMode="decimal"
                  className="form-control"
                  onChange={defineCredenciais}
                  name='porcentagemPremio'
                  value={credenciais.porcentagemPremio ?? ''}
                  disabled={bloqueado}
                />
              </>
            )}
          </div>

          <div className="form-group">
            {credenciais.tipo === 'placar' ? (
              <>
                <label className="control-label">{confrontos.length - 1} acertos</label>
                <input
                  required
                  type="number"
                  inputMode="decimal"
                  className="form-control"
                  onChange={defineCredenciais}
                  name='premio2'
                  value={credenciais.premio2 ?? ''}
                  disabled={bloqueado}
                />
              </>
            ) : (
              <>
                <label className="control-label">Premio</label>
                <input
                  required
                  type="number"
                  inputMode="decimal"
                  className="form-control"
                  onChange={defineCredenciais}
                  name='premioAcumulado'
                  value={credenciais.premioAcumulado ?? ''}
                  disabled={bloqueado}
                />
              </>
            )}
          </div>

          <div className="form-group">
            {credenciais.tipo === 'placar' && (
              <>
                <label className="control-label">{confrontos.length - 2} acertos</label>
                <input
                  required
                  type="number"
                  inputMode="decimal"
                  className="form-control"
                  onChange={defineCredenciais}
                  name='premio3'
                  value={credenciais.premio3 ?? ''}
                  disabled={bloqueado}
                />
              </>
            )}
          </div>
        </div>
      </div>

      <div className="titulo-principal mt-2">
        <div className="mb-0 my-auto">Times</div>
        <div className="ms-auto">
          <button
            type="button"
            className="btn btn-info"
            onClick={() => ListaTimes(setTimes)}
            disabled={bloqueado}
          >
            <i className="fa fa-plus" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div className="conteudo-principal">
        <div className="d-flex quatro-colunas">
          <label className="control-label">Time Casa</label>
          <label className="control-label">Time Fora</label>
          <label className="control-label">Data</label>
          <label className="control-label">Horário</label>
        </div>

        {confrontos.map((el, ind) => (
          <div className="d-flex quatro-colunas" key={ind}>
            <div className="form-group">
              <input
                required
                className="form-control"
                name="casa"
                id={ind}
                value={el.casa}
                onChange={defineConfrontos}
                list="times"
                autoComplete="off"
                disabled={bloqueado}
              />
              <datalist id="times">
                <option value=""/>
                {times && times.map(t => (
                  <option key={t.id} value={t.name}>{t.name}</option>
                ))}
              </datalist>
            </div>

            <div className="form-group">
              <input
                required
                className="form-control"
                name="fora"
                id={ind}
                value={el.fora}
                onChange={defineConfrontos}
                list="times"
                autoComplete="off"
                disabled={bloqueado}
              />
              <datalist id="times">
                <option value=""/>
                {times && times.map(t => (
                  <option key={t.id} value={t.name}>{t.name}</option>
                ))}
              </datalist>
            </div>

            <div className="form-group">
              <input
                required
                type="date"
                className="form-control"
                name="data"
                id={ind}
                value={el.data}
                onChange={defineConfrontos}
                disabled={bloqueado}
              />
            </div>

            <div className="form-group">
              <input
                required
                type="time"
                className="form-control"
                name="hora"
                id={ind}
                value={el.hora}
                onChange={defineConfrontos}
                disabled={bloqueado}
              />
            </div>
          </div>
        ))}

        <button className="btn btn-secondary" onClick={adicionarTime} type="button" disabled={bloqueado}>
          Adicionar time
        </button>
        <button className="btn btn-info ml-2" onClick={removerTime} type="button" disabled={bloqueado}>
          Remover time
        </button>
      </div>

      <div className="d-flex duas-colunas m-t">
        <button className="btn btn-danger" type="button" onClick={() => props.history.push('/bolao')}>
          Cancelar
        </button>
        <button className="btn btn-success" type="submit" disabled={bloqueado}>
          Salvar
        </button>
      </div>
    </form>
  );
}
